import {
  ROUTEDETAIL,
  RouteDetail,
  RESET_RADAR_ROUTE_DETAIL,
} from 'store/actions/radarRouteDetail';

const initialState: RouteDetail = {
  routeDetailName: '',
  isActive: false,
};

export const radarRouteDetailReducer = (
  state = initialState,
  action: { type: string; payload?: RouteDetail }
): RouteDetail => {
  switch (action.type) {
    case ROUTEDETAIL:
      return { ...state, ...action.payload };
    case RESET_RADAR_ROUTE_DETAIL:
      return initialState;
    default:
      return state;
  }
};
